import React, {Component} from 'react';
import Modal from "react-modal";
import HttpClient from "services/HttpClient";
import './styles.css';

const ATTENDEES_URL = '/api/v1/workshops/attendees';
const REFUNDED_URL = '/api/v1/workshops/refund_attendees';
const CPD_URL = '/api/v1/workshops/cpd';
const CPD_PENDING_URL = '/api/v1/workshops/cpd_pending';
const CERT_URL = '/api/v1/pdfs?token='

class WorkshopDetailsModal extends Component {
  constructor() {
    super();

    this.state = {
      items: [],
      hasMore: false,
      page: 1,
      total_pages: 1,
      isLoading: false,
    };
  };

  componentDidMount() {
    const {page} = this.state;
    const url = this.getUrl();
    this.setState({isLoading: true}, () => {
      new HttpClient().get(`${url}?page=${page}`).then(response => {
        console.log("url from ONLINE_WORKSHOPS", response.body.data.workshops);
        this.setState({
          items: response.body.data.workshops,
          total_pages: response.body.data.pages,
          hasMore: page < response.body.data.pages,
          isLoading: false,
        });
      });
    });
  }

  generateSertificate = token => {
    const url = `${CERT_URL}${token}`;
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Token token=${localStorage.token}`);
    let init = {
      method: "GET",
      headers: headers,
      cache: "no-cache"
    };
    fetch(url, init)
    .then(resp => {
      if(resp.status=='200') {
        resp.blob()
        .then(file => {
          let objUrl = window.URL.createObjectURL(file)
          window.open(objUrl)
        })
      } else {
        alert("Something went wrong. Please check your connection or try again later")
      }
    });
  }

  getUrl = () => {
    const {modalType, id} = this.props;
    switch(modalType) {
      case 'attendees':
        return `${ATTENDEES_URL}/${id}`;
      case 'attendees_refunded':
        return `${REFUNDED_URL}/${id}`;
      case 'cpd':
        return `${CPD_URL}/${id}`;
      case 'cpd_pending':
        return `${CPD_PENDING_URL}/${id}`;
      default:
        return '';
    }
  }

  handleFetch = () => {
    console.log('nexppage')
    const {page, items} = this.state;
    const url = this.getUrl();
    const newPage = page + 1;

    this.setState({isLoading: true}, () => {
      new HttpClient().get(`${url}?page=${newPage}`).then(response => {
        console.log("url from ONLINE_WORKSHOPS", response.body.data.workshops);
        this.setState({
          items: [...items, ...response.body.data.workshops],
          page: newPage,
          hasMore: newPage < response.body.data.pages,
          total_pages: response.body.data.pages,
          isLoading: false,
        });
      });
    });
  }

  renderAttendees = () => {
    const {items} = this.state;
    return (
      <table className="wd-items-container">
        <thead>
          <tr>
            <th className="wd-table-item wd-table-header">#</th>
            <th className="wd-table-item wd-table-header">Name</th>
            <th className="wd-table-item wd-table-header">Date/Time of Purchase</th>
            <th className="wd-table-item wd-table-header">Amount Paid</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={item.purchased_by.id} className="wd-item-container">
                <td className="wd-table-item">{index + 1}</td>
                <td className="wd-table-item">{item.purchased_by.full_name}</td>
                <td className="wd-table-item">{item.purchased_at}</td>
                <td className="wd-table-item">{`${item.cost} €`}</td>
              </tr>
            );
        })}
        </tbody>
      </table>
    );
  }

  renderAttendeesRefunded = () => {
    const {items} = this.state;
    return (
      <table className="wd-items-container">
        <thead>
          <tr>
            <th className="wd-table-item wd-table-header">#</th>
            <th className="wd-table-item wd-table-header">Name</th>
            <th className="wd-table-item wd-table-header">Date/Time of Refund</th>
            <th className="wd-table-item wd-table-header">Amount Refunded</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={item.id} className="wd-item-container">
                <td className="wd-table-item">{index + 1}</td>
                <td className="wd-table-item">{item.purchased_by.full_name}</td>
                <td className="wd-table-item">{item.refunded_at}</td>
                <td className="wd-table-item">{`${item.cost} €`}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  renderCPD = () => {
    const {items} = this.state;
    return (
      <table className="wd-items-container">
        <thead>
          <tr>
            <th className="wd-table-item wd-table-header">Name</th>
            <th className="wd-table-item wd-table-header">CPD Completion Date</th>
            <th className="wd-table-item wd-table-header">Download CPD</th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => {
            return (
              <tr key={item.id} className="wd-item-container">
                <td className="wd-table-item">{item.user.full_name}</td>
                <td className="wd-table-item">{item.completion_date}</td>
                <td className="wd-table-item">
                  <a href="#" onClick={() => this.generateSertificate(item.token)}>Download cert</a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  renderCPDPending = () => {
    const {items} = this.state;
    return (
      <table className="wd-items-container">
        <thead>
          <tr>
            <th className="wd-table-item wd-table-header">Name</th>
            <th className="wd-table-item wd-table-header">Date/Time of Purchase</th>
            <th className="wd-table-item wd-table-header">Amount Paid</th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => {
            return (
              <tr key={item.purchased_by.id} className="wd-item-container">
                <td className="wd-table-item">{item.purchased_by.full_name}</td>
                <td className="wd-table-item">{item.purchased_at}</td>
                <td className="wd-table-item">{`${item.cost} €`}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  renderContent = type => {
    switch(type) {
      case 'attendees':
        return this.renderAttendees();
      case 'attendees_refunded':
        return this.renderAttendeesRefunded();
      case 'cpd':
        return this.renderCPD();
      case 'cpd_pending':
        return this.renderCPDPending();
      default:
        return null;
    }
  }

  render() {
    const {modalOpened, closeModal, modalType} = this.props;
    const {hasMore, isLoading} = this.state;
    return (
      <Modal
        isOpen={modalOpened}
        closeTimeoutMS={100}
        contentLabel="Modal"
      >
        <div className="wd-modal-container">
          <h1 className="wd-modal-header">{modalType.replace('_', ' ')}</h1>
          <div id="scrollableWrapper" className="wd-scroll-table">
            {/* <InfiniteScroll
              next={this.handleFetch}
              hasMore={hasMore}
              loader={<h4>Loading...</h4>}
              scrollableTarget="scrollableWrapper"
            > */}
              {this.renderContent(modalType)}
            {/* </InfiniteScroll> */}
          </div>
          {hasMore && (
            <div className="modal-permissions-button" style={{justifyContent: "center"}}>
              <div className="workshop-creator-sidebar-publish">
                <span className="btn prime bordered" onClick={this.handleFetch}>
                  {isLoading ? '...' : 'Load more'}
                </span>
              </div>
            </div>
          )}
          <div className="modal-permissions-button" style={{justifyContent: "center"}}>
            <div className="workshop-creator-sidebar-publish">
              <span className="btn prime bordered red" onClick={closeModal}>
                Close
              </span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default WorkshopDetailsModal;



// WEBPACK FOOTER //
// ./src/blocks/workshopDetailsModal/index.jsx